import React from 'react';
import { useNavigate } from 'react-router-dom';

//Redux and action creators
import { connect } from 'react-redux';

import getRoleGroupByRole from '@utils/dashboard/getRoleGroupbyRole';

//Components
import ScreenPopContainer from './ScreenPopContainer';
import NavBarContainer from '../common/NavBarContainer';


//Constants
import { ALL_USER_ROLES, USER_GROUPS } from '@constants/roles/userRoleTypes';
import { configs } from '@constants/configs/configs';

const CrmContainer = props => {
    const {
        environment: {
            user: {
                role
            },
        }
    } = props;

    let navigate = useNavigate();

    const roleGroup = getRoleGroupByRole(role);

    if(![USER_GROUPS.CSR_GROUP, ALL_USER_ROLES.ADMIN].includes(roleGroup)){
        navigate(configs.routes.HOME);
    }

    return (
        <div>
            <div id="delegation" className="usa-layout-docs usa-section gi-main-section delegation">
                <div className="grid-container grid-widescreen gi-grid-container">
                    <div className="grid-row grid-gap">
                        <NavBarContainer roleGroup={roleGroup} arrayOfUserRoles={[USER_GROUPS.CSR_GROUP, ALL_USER_ROLES.ADMIN]} navBarClass='broker-top-nav width-full'/>
                        <div className='usa-layout-docs__main desktop:grid-col-12' id="main-content">
                            <div className='main-content__crm'>
                                <ScreenPopContainer/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    spinner: state.common.spinner,
    environment: state.common.environment,
    delegation: state.delegation
});

export default connect(mapStateToProps )(CrmContainer);
